import { ref, onMounted, watch } from 'vue';
import http from '@/http.js';
import eventBus from '@/eventBus.js';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function useRequeteItem(props) {
    const showModalAnomalieIn = ref(false);
    const anomalies = ref([]);
    const nomChamps = ref([]);
    const loaded = ref(true);

    watch(anomalies, (newAnomalies) => {
        nomChamps.value = [];
        if (newAnomalies.length > 0) {
            for (let i = 0; i < newAnomalies[0].champsLigneAnomalie.length; i++) {
                nomChamps.value.push(newAnomalies[0].champsLigneAnomalie[i].nomChamp);
            }
        }
    });

    const getAnomaliesToJustif = async () => {
        try {
            const data = await http.getAnomaliesToJustif(props.idExecution, props.requete.idRequete);
            anomalies.value = data;
        } catch (error) {
            console.error("Erreur lors de la récupération des anomalies : ", error);
        }
    };

    const handleShowModalAnomalieIn = async (idExecution, idRequete) => {
        loaded.value = false;
        try {
            const data = await http.getAnomaliesToJustif(idExecution, idRequete);
            anomalies.value = data;
        } finally {
            loaded.value = true;
        }
        showModalAnomalieIn.value = !showModalAnomalieIn.value;
    };

    onMounted(() => {
        eventBus.on('reloadAnomaliesToJustif', getAnomaliesToJustif);
    });

    return {
        showModalAnomalieIn,
        anomalies,
        nomChamps,
        loaded,
        handleShowModalAnomalieIn,
    };
}